import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Textarea } from "@/components/ui/textarea"
import { X } from "lucide-react"

interface UploadedFile {
  name: string;
  url: string;
}

interface FileUploadStepProps {
  value: string;
  uploading: boolean;
  uploadedFiles: UploadedFile[];
  onInputChange: (value: string) => void;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: (file: UploadedFile) => void;
  placeholder: string;
}

export const FileUploadStep = ({
  value,
  uploading,
  uploadedFiles,
  onInputChange,
  onFileChange,
  onRemoveFile,
  placeholder,
}: FileUploadStepProps) => {
  return (
    <div className="space-y-4">
      <div className="grid w-full max-w-sm items-center gap-1.5">
        <Input
          type="file"
          accept=".pdf,image/*"
          onChange={onFileChange}
          disabled={uploading}
          className="cursor-pointer"
        />
        <p className="text-sm text-gray-500 mt-1">
          You can also paste images directly from your clipboard
        </p>
      </div>
      {uploadedFiles.length > 0 && (
        <div className="space-y-2">
          <p className="text-sm text-gray-500">Uploaded files:</p>
          {uploadedFiles.map((file, index) => (
            <div key={index} className="flex items-center justify-between bg-accent p-2 rounded-md">
              <div className="flex items-center space-x-2 flex-1 min-w-0">
                <span className="text-sm truncate">{file.name}</span>
                {file.url.match(/\.(jpg|jpeg|png|gif|webp)$/i) && (
                  <img 
                    src={file.url} 
                    alt={file.name}
                    className="h-8 w-8 object-cover rounded"
                  />
                )}
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onRemoveFile(file)}
                className="h-8 w-8 p-0 ml-2"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
      <Textarea
        value={value}
        onChange={(e) => onInputChange(e.target.value)}
        placeholder={placeholder}
        className="w-full min-h-[120px]"
      />
    </div>
  )
}